export default class Dropdown {

    constructor(el, options = {}){
        
        if( el.multiple ) return; // multiple not supported
        if( typeof el.custom_dropdown !== 'undefined' ) return;

        this.el = el;
        this.options = options;
        // this.options.animation_open = options.animation_open ?? 'fade-in-bottom-short 0.4s cubic-bezier(0.39, 0.575, 0.565, 1) both';
        this.options.animation_open = options.animation_open ?? '';
        this.init();

        this.el.custom_dropdown = this;
    }

    init(){
        this.is_open = false;
        this.selected = null;
        this.el.style.display = 'none';
        this.create_html();
    }

    create_html(){
        this.container = document.createElement('div');
        this.container.classList.add('dropdown_style');
        this.el.after(this.container);
        
        this.create_trigger();
        this.create_options();

        this.set_width();
    }
    
    create_trigger(){
        let trigger = document.createElement('div');
        this.trigger = trigger;
        trigger.classList.add('trigger');
        this.container.append(trigger);
        
        trigger.textContent = this.el.options[this.el.selectedIndex].textContent;

        trigger.addEventListener('click', ()=>{
            if( this.is_open ) {
                this.close();
            }
            else {
                this.open();
            }
        });
    }

    create_options(){
        
        let options_container = document.createElement('div');
        this.options_container = options_container;
        options_container.classList.add('options');
        this.container.append(options_container);
        options_container.style.display = 'none';
        
        for( let i = 0; i < this.el.options.length; i++ ) {
            let option = this.el.options[i];
            
            let clone_option = document.createElement('div');
            clone_option.className = option.className;
            clone_option.classList.add('option');
            clone_option.textContent = option.textContent;
            clone_option.value = option.value;

            if( option.selected ) {
                this.selected = clone_option;
                clone_option.classList.add('selected');
            }

            clone_option.addEventListener('click', ()=>{
                this.select(clone_option);
            });

            options_container.append(clone_option);
        }
    }

    open(){
        this.close_others();

        this.is_open = true;
        this.container.classList.add('open');
        
        this.options_container.style.display = '';
        this.options_container.style.animation = this.options.animation_open;

        window.current_custom_dropdown = this;

        this.close_handler();
    }

    close(){
        this.is_open = false;
        this.container.classList.remove('open');
        this.options_container.style.display = 'none';
        this.close_handler_cleanup();
    }

    select(option){
        this.selected = option;
        this.trigger.textContent = option.textContent;
        this.close();
        this.el.value = option.value;
        this.el.dispatchEvent(new Event('change'));
        
        if( typeof this.options.on_select === 'function' ) {
            this.options.on_select();
        }
    }

    close_others(){
        if( typeof window.current_custom_dropdown !== 'undefined' ) {
            window.current_custom_dropdown.close();
        }
    }
    
    close_handler(){
        document.addEventListener('keydown', this.keydown_handler);
        document.addEventListener('click', this.outside_click_handler);
    }

    close_handler_cleanup(){
        document.removeEventListener('keydown', this.keydown_handler);
        document.removeEventListener('click', this.outside_click_handler);
    }

    outside_click_handler(e){
        if( !e.target.closest('.dropdown_style') ) {
            window.current_custom_dropdown.close();
        }
    }

    keydown_handler(e){
        if( e.code == 'Escape' ) {
            window.current_custom_dropdown.close();
        }
    }

    set_width(){

        let width = this.el.style.width;

        if( !width ) {

            if( !this.container.offsetWidth ) {
                return;
            }

            width = this.container.offsetWidth + 'px';
        }
        
        this.container.style.width = width;
    }

}